const inputWidth = 180;
const aggregator = "finicity";
const dateFormat = "MM-YYYY";

const SUCCESS_STATUS = "OK";
export { dateFormat, inputWidth, aggregator, SUCCESS_STATUS };
